export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ06.f2836931.mp3";